import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import { useSelector } from "react-redux";
import { selectUserInfo } from "../../redux/userSlice";

export default function WhatsappDirectChatIcon() {
  const userInfo = useSelector(selectUserInfo);

  // Only show for non‑admin roles
  if (userInfo?.data?.role === 1) return null;

  return (
    <a
      href="https://wa.me/14162943015"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-[196px] right-7 rounded-full bg-[#25D366] p-3 text-white shadow-lg transition-shadow hover:shadow-xl"
      style={{
        zIndex: 9,
      }}
      aria-label="Chat on WhatsApp"
    >
      <FaWhatsapp size={24} />
    </a>
  );
}
